import { Button } from "@mui/material";
import { useState } from "react";

const NormalBtn = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  //필수 name (버튼명) + 테마 선택(기본:blueStyle)

  const btnTextStyle = {
    fontWeight: "400",
    fontsize: "0.875rem",
    borderRadius: props.radiusNone ? "0px" : props.borderRadius ? props.borderRadius : "5px",
    fontFamily: "AppleSDGothicNeo",
    fontSize: "0.938rem",
    lineHeight: "normal",
    letterSpacing: "normal",
    padding: props.padding ? props.padding : "0.6rem 1rem 0.5rem 1rem",
    minWidth: props.width ? props.width : props.search ? "6.25rem" : "5.375rem",
    margin: props.margin,
    width: props.fullWidth ? "100%" : "",
    height: props.height ? props.height : "2.25rem",
  };

  const whiteStyle = {
    ...btnTextStyle,
    border: props.disabled ? "1px solid #777777" : "1px solid #032063",
    backgroundColor: props.disabled ? "#C6C6C6" : "#FFFFFF",
    color: props.disabled ? "#777777" : "#032063",
  };
  const grayStyle = {
    ...btnTextStyle,
    border: props.disabled ? "1px solid #777777" : "1px solid #BBBBBB",
    backgroundColor: props.disabled ? "#C6C6C6" : "#FFFFFF",
    color: props.disabled ? "#777777" : " #222222",
  };
  const blueStyle = {
    ...btnTextStyle,
    margin: props.margin,
    backgroundColor: props.disabled ? "#C6C6C6" : "#032063",
    color: props.disabled ? "#777777" : " #FFFFFF",
  };
  const greenStyle = {
    ...btnTextStyle,
    backgroundColor: props.disabled ? "#C6C6C6" : "#217346",
    color: props.disabled ? "#777777" : " #FFFFFF",
  };
  const redStyle = {
    ...btnTextStyle,
    backgroundColor: props.disabled ? "#C6C6C6" : "#8a2929",
    color: props.disabled ? "#777777" : " #FFFFFF",
  };
  const redOutlinedStyle = {
    ...btnTextStyle,
    border: props.disabled ? "1px solid #777777" : "1px solid #8a2929",
    backgroundColor: props.disabled ? "#C6C6C6" : "#FFFFFF",
    color: props.disabled ? "#777777" : "#8a2929",
  };
  const hiddenStyle = {
    ...btnTextStyle,
    visibility: "hidden",
  };
  const registerStyle = {
    ...btnTextStyle,
    marginTop: "1.5rem",
    width: "23.312rem",
    height: "3.125rem",
    borderRadius: "5px",
    border: props.disabled ? "solid 2px #999da5" : "solid 2px #032063",
    backgroundColor: "#fff",
    fontSize: "1.125rem",
    fontWeight: "bold",
    textAlign: "center",
    color: props.disabled ? "#999da5" : "#032063",
  };
  const grpActiveStyle = {
    ...btnTextStyle,
    // borderRadius: "0",
    backgroundColor: "#032063",
    fontFamily: "AppleSDGothicNeo",
    fontSize: "0.938rem",
    fontWeight: "400",
    fontStretch: "normal",
    fontStyle: "normal",
    color: "#fff",
    border: "1px solid #b1bdff",
  };

  const grpDeactiveStyle = {
    ...btnTextStyle,
    backgroundColor: isHovered ? "#2B4B8B" : "#fff",
    color: isHovered ? "#fff" : "#a7a7a7",
    border: "1px solid #b9b9b9",
  };

  const grpDisabledStyle = {
    ...btnTextStyle,
    backgroundColor: "#b8b8b8",
    color: "white",
    border: "1px solid #acacac",
  };

  const btnColorTheme = () => {
    if (props.theme === "blue") {
      return blueStyle;
    } else if (props.theme === "gray") {
      return grayStyle;
    } else if (props.theme === "white") {
      return whiteStyle;
    } else if (props.theme === "green") {
      return greenStyle;
    } else if (props.theme === "red") {
      return redStyle;
    } else if (props.theme === "redOutlined") {
      return redOutlinedStyle;
    } else if (props.theme === "hidden") {
      return hiddenStyle;
    } else if (props.theme === "register") {
      return registerStyle;
    } else if (props.theme === "grpActive") {
      return grpActiveStyle;
    } else if (props.theme === "grpDeactive") {
      return grpDeactiveStyle;
    } else if (props.theme === "grpDisabled") {
      return grpDisabledStyle;
    } else {
      return blueStyle;
    }
  };

  return (
    <Button
      onMouseEnter={() => props.isHover && !props.disabled && setIsHovered(true)}
      onMouseLeave={() => props.isHover && setIsHovered(false)}
      style={btnColorTheme()}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.name}
    </Button>
  );
};

export default NormalBtn;
